var a = (l, e, r) => new Promise((f, d) => {
  var h = (s) => {
    try {
      i(r.next(s));
    } catch (o) {
      d(o);
    }
  }, u = (s) => {
    try {
      i(r.throw(s));
    } catch (o) {
      d(o);
    }
  }, i = (s) => s.done ? f(s.value) : Promise.resolve(s.value).then(h, u);
  i((r = r.apply(l, e)).next());
});
import { B as g } from "./buffer-DIFxvF2Q.js";
class n extends g {
  getSession() {
    return this._isLoaded ? this._bufferCall("getSession", []) : null;
  }
  start(e) {
    return a(this, null, function* () {
      return this._sdk.start(e);
    });
  }
  stop() {
    return this._sdk.stop();
  }
  addSessionProperties(e) {
    return this._bufferCall("addSessionProperties", [e]);
  }
  getRecordingState() {
    return this._isLoaded ? this._bufferCall("getRecordingState", []) : "NotRecording";
  }
  snapshot(e) {
    return this._isLoaded ? this._bufferCall("snapshot", [e]) : Promise.resolve(void 0);
  }
  register(e, r) {
    return this._bufferCall("register", [e, r]);
  }
}
let t;
typeof globalThis != "undefined" ? globalThis.LDRecord ? t = globalThis.LDRecord : (t = new n(), globalThis.LDRecord = t) : t = new n();
export {
  t as LDRecord
};
//# sourceMappingURL=LDRecord.js.map
